<template>
  <ion-list class="ccy">
    <ion-item>
      <ion-select
        data-test="ccy-currency"
        :label="modelValue.fixed ? 'Currency' : 'Default currency'"
        interface="popover"
        :value="modelValue.currency"
        :selected-text="modelValue.currency"
        @ion-change="update({ currency: String($event.detail.value) })"
      >
        <ion-select-option v-for="option in options" :key="option.code" :value="option.code">
          {{ option.code }} — {{ option.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-toggle
        data-test="ccy-fixed"
        :checked="modelValue.fixed"
        justify="space-between"
        @ion-change="update({ fixed: $event.detail.checked })"
      >Fixed (cannot be changed when filling in)</ion-toggle>
    </ion-item>
    <ion-item lines="none">
      <ion-label class="ion-text-wrap" color="medium">
        <p>{{ summary }}</p>
      </ion-label>
    </ion-item>
  </ion-list>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { IonItem, IonLabel, IonList, IonSelect, IonSelectOption, IonToggle } from "@ionic/vue";
import { currencyOptions, fractionDigits, type ResolvedCurrencyConfig } from "@/helper/currency";

const props = defineProps<{ modelValue: ResolvedCurrencyConfig }>();
const emit = defineEmits<{ (e: "update:modelValue", value: ResolvedCurrencyConfig): void }>();

const options = currencyOptions();

function update(patch: Partial<ResolvedCurrencyConfig>) {
  emit("update:modelValue", { ...props.modelValue, ...patch });
}

const summary = computed(() => {
  const { currency, fixed } = props.modelValue;
  const digits = fractionDigits(currency);
  const decimals = digits === 0 ? "without decimals" : `with ${digits} decimals`;
  return fixed
    ? `Stores amounts in ${currency}, ${decimals}.`
    : `Stores amounts ${decimals}, starting on ${currency}. The currency can be chosen when filling in.`;
});
</script>
